<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
      <div class="tu-class">
        <p v-html="strnei" >{{strnei}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 审批意见
        <div class="nr-class">
          <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
            <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p class="yjp-class">
            <el-upload
              name="img"
              class="upload-demo"
              :action="url"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              list-type="picture">
              <el-button size="small" type="primary">上传发票图片</el-button>
            </el-upload>
          </p>
          <p class="yjp-class">
            <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
          </p>
          <el-button type="primary" @click="submit" style="margin-top: 20px;">提交</el-button>
        </div>
      </h3>
    </div>
  </div>
</template>
<script>
import { processInstanceImage } from "@/api/api.js";//流程图
import { processData } from "@/api/api.js";//附加单据
import { submitTask } from "@/api/api.js";//审批意见提交
export default {
  name:'processTransaction',
  data() {
    return{
      processId:'',
      id:'',
      str:"",
      strnei:"",
      queryParams:{
        remark:""
      },
      source:[
        {
          value:1,
          label:"同意"
        },
        {
          value:2,
          label:"不同意"
        },
      ],
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
      gaibianurl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
      file:""
    }
  },

  methods: {
     // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;

      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader();
      reader.onload = event => {
        preview.innerHTML = `<img src="${event.target.result}" class = 'imgclass'>`;
      };
      reader.readAsDataURL(file);
      this.file = file;
    },
    // 获取数据
    initData(){
      let params ={
        processInstanceId:this.processId
      }
      processInstanceImage(params).then(res=>{
        this.str = res.data
      });
      processData(params).then(res=>{
        if (res.data.code == 200) {
          this.strnei = res.data.data;
        }
      })
    },
    handleAvatarSuccess(res, file){
      if(res.code == 200){
        this.queryParams.remark = this.gaibianurl + res.data;
      }
    },
    // 提交
    submit(){
      if (!this.queryParams.remark||!this.queryParams.status) return this.$message.error("请输入审批内容或结果");
      let params = {
        ...this.queryParams,
        taskId:this.id
      }
      submitTask(params).then(res=>{
        if(res.data.code == 200){
          this.$router.push({ path: `/personalOffice/myMission` });
          this.$notify({
            title: '成功',
            message: '审批成功',
            type: 'success'
          });
        }
      })
    }
  },
  created() {
    this.processId =  this.$route.params && this.$route.params.processId;
    this.id =  this.$route.params && this.$route.params.id;
  },
  mounted() {
    this.initData()
  },
};
</script>
<style scoped lang="less">
.zhantie{
  width: 50%;
  height: 230px;
  border: 1px solid #DCDFE6;
  overflow: hidden;
  margin-top: 22px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size:14px;
    color: #C0C4CC;
  }
}
.imgclass{
  width: 300px;
  height: 100px;
}
.lct-class{
  padding-bottom: 50px;
  .detail-h3 {
    font-size: 20px;
    color: #000000;
    padding-bottom: 30px;
    box-sizing: border-box;
  }
  .detail-h3 i {
    color: #5298ff;
  }
  .nr-class{
    margin-top: 20px;
    margin-left: 10px;
  }
  .yjp-class{
    margin-top: 20px;
  }
}
</style>


